module.exports = require("./pixi-multistyle-text").default;